import { AvatarWithId, Team } from './types';

export const transformTeamToAvatar: (team: Team) => AvatarWithId = team => ({
  id: team.id,
  fallbackText: team.name,
  type: 'team',
  tooltipText: team.tooltipText,
  status: team.archived ? 'archived' : undefined,
});
